function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0x9c96a0;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;
    var itemsPositionsObject = { i3_6: { x: 861, y: 216, w: 107, h: 106, n: "i3_6" }, i3_5: { x: 78, y: 193, w: 90, h: 89, n: "i3_5" }, i3_4: { x: 647, y: 513, w: 90, h: 89, n: "i3_4" }, i3_3: { x: 375, y: 323, w: 90, h: 89, n: "i3_3" }, i3_2: { x: 257, y: 193, w: 90, h: 89, n: "i3_2" }, i3_1: { x: 595, y: 183, w: 90, h: 89, n: "i3_1" }, i3_0: { x: 762, y: 135, w: 90, h: 89, n: "i3_0" }, i2_6: { x: 640, y: 305, w: 90, h: 89, n: "i2_6" }, i2_5: { x: 80, y: -3, w: 90, h: 89, n: "i2_5" }, i2_4: { x: 2, y: 261, w: 90, h: 89, n: "i2_4" }, i2_3: { x: 238, y: 337, w: 90, h: 89, n: "i2_3" }, i2_2: { x: 96, y: 185, w: 90, h: 89, n: "i2_2" }, i2_1: { x: 894, y: 237, w: 90, h: 89, n: "i2_1" }, i2_0: { x: 557, y: 199, w: 90, h: 89, n: "i2_0" }, i1_6: { x: 372, y: 167, w: 118, h: 118, n: "i1_6" }, i1_5: { x: 25, y: 45, w: 118, h: 118, n: "i1_5" }, i1_4: { x: 655, y: 343, w: 90, h: 89, n: "i1_4" }, i1_3: { x: 142, y: 184, w: 118, h: 118, n: "i1_3" }, i1_2: { x: 694, y: 195, w: 118, h: 118, n: "i1_2" }, i1_1: { x: 678, y: 9, w: 118, h: 118, n: "i1_1" }, i1_0: { x: 612, y: 428, w: 118, h: 118, n: "i1_0" } };
    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);
        document.addEventListener('stopGame', onStopGame, true);
        document.addEventListener('refreshCounter', onRefreshCounter, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        onRefreshCounter();

        cycleGame();
    }
    function onRefreshCounter(e) {
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
    }
    function onStartGame() {

    }

    function onStopGame() {
        end();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {

            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {
            if (gameData.scene.getGameIndex() < 3) {

                renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
                setTimeout(startNewLevel, 1000);
            } else {
                setTimeout(end, 1600);
            }

        }

    }
    function startNewLevel() {

        gameData.scene.setState('newLevel');
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
    }
    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 7;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(285, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject, gameData);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        // if (gameData.numItems > 1) {
        game.gameContainer.addChild(counter.container);
        //  }

    }


    function positionGameItems() {
        sprites.btn_gioca.x = 685;
        sprites.btn_gioca.y = 275;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);


    }

    function onAnswerWrong(e) {
        //  gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions, _gameData) {
    var name = sceneName;
    var gameData = _gameData;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;

    var levels = {};

    levels.level_01 = {
        container: new Container(),

        buttons: ['i1_0', 'i1_1', 'i1_2', 'i1_3', 'i1_4', 'i1_5', 'i1_6']

    };
    levels.level_02 = {
        container: new Container(),

        buttons: ['i2_0', 'i2_1', 'i2_2', 'i2_3', 'i2_4', 'i2_5', 'i2_6']
    };
    levels.level_03 = {
        container: new Container(),

        buttons: ['i3_0', 'i3_1', 'i3_2', 'i3_3', 'i3_4', 'i3_5', 'i3_6']
    };


    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;


    var buttonsContainer;


    var gameIndex = 0;
    var sceneElements = {};
    var levelNames = ['01', '02', '03'];

    var currentLevelData;
    var currentLevelContainer;
    var currentLevelName;
    var currentButton;

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);
    this.getGameIndex = function () {
        return gameIndex;
    }

    initScene();
    gameData.numItems = 7;
    function initScene() {
        var i, ii;

        var spriteItem;
        var pos;

        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            container.addChild(currentLevelContainer);
            buttonsContainer = new Container();
            buttonsContainer.interactive = true;
            sceneElements['buttonsContainer_' + currentLevelName] = buttonsContainer;
            for (ii = 0; ii < currentLevelData.buttons.length; ii++) {

                spriteItem = new PIXI.Graphics();
                spriteItem.beginFill("0xff0000", 0);
                spriteItem.lineColor = "0xff0000";
                spriteItem.lineAlpha = 1;
                spriteItem.lineWidth = 4;
                pos = positions[currentLevelData.buttons[ii]];
                spriteItem.drawCircle(pos.x + pos.w / 2, pos.y + pos.w / 2, pos.w / 2);
                spriteItem.endFill();
                spriteItem.name = currentLevelData.buttons[ii];
                spriteItem.interactive = true;

                buttonsContainer.addChild(spriteItem);
                sceneElements[currentLevelData.buttons[ii]] = spriteItem;
            }

            spriteItem = game.sprites["l_" + currentLevelName];
            pos = positions[currentLevelName];
            currentLevelContainer.addChild(spriteItem);
            sceneElements[currentLevelName] = spriteItem;



            currentLevelContainer.alpha = 0;
            currentLevelContainer.addChild(buttonsContainer);

            buttonsContainer.on('pointertap', onClick);
        }

    }


    function clear() {


    }

    function reset() {
        levelNames = _.shuffle(levelNames);
        gameIndex = 0;
        setState('newLevel');
    }

    function resetLevels() {
        var i;

        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            levels['level_' + currentLevelName].container.alpha = 0;
            sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = false;
            for (ii = 0; ii < levels['level_' + currentLevelName].buttons.length; ii++) {
                spriteItem = sceneElements[levels['level_' + currentLevelName].buttons[ii]];
                spriteItem.alpha = 0;
                spriteItem.interactive = true;
            }
        }
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                resetLevels();


                levelNames.push(levelNames.shift());
                currentLevelName = levelNames[0];
                currentLevelData = levels['level_' + currentLevelName];
                gameData.numItems = currentLevelData.buttons.length;
                gameData.currentItem = 0;
                document.dispatchEvent(new Event('refreshCounter'));
                loopSequence = [renderOnce];
                currentLevelContainer = currentLevelData.container;
                currentLevelContainer.alpha = 1;
                sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = true;
                theGame.cycleGame();
                loopSequence = [renderOnce];

                break;
            case 'ready':
                loopSequence = [renderOnce];
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }


    function onClick(e) {

        if (currentState === "ready") {
            var clicked = e.target.name;
            var ok = false;
            if (currentLevelData.buttons.indexOf(clicked) > -1) {
                //se non è stato usato


                if (sceneElements[clicked].alpha === 0) {
                    sceneElements[clicked].interactive = false;
                    sceneElements[clicked].alpha = 1;
                    ok = true;
                }

            }
            if (ok) {

                setState('animating');
                renderer.view.dispatchEvent(new Event('answerOk'));
                setTimeout(okComplete, 1000);
            } else {
                setState('animating');
                renderer.view.dispatchEvent(new Event('answerWrong'));
                setTimeout(wrongComplete, 1000);
            }


            loopSequence = [renderOnce];
        }
    }


    function okComplete() {
        if (gameData.currentItem === gameData.numItems) {
            gameIndex++;
        }
        /*  
          if (gameIndex < 3) {
              setState('newLevel');
          }*/
        theGame.cycleGame();
        loopSequence = [renderOnce];

    }


    function wrongComplete() {
        //  gameIndex++;
        theGame.cycleGame();

        //  setState('ready');
        //  loopSequence = [renderOnce];
    }
}